import { type MessageKey } from '@ecom/i18n';

/** Mirrors `PlatformAccount` of `apps/api/src/modules/identity/platform-account.service.ts`. */
export interface PlatformAccount {
  readonly userId: string;
  readonly email: string;
  readonly displayName: string | null;
  readonly role: 'superadmin' | 'platform_admin';
  readonly status: 'active' | 'disabled';
  readonly lockedUntil: string | null;
  readonly lastLoginAt: string | null;
  readonly createdAt: string;
  readonly mustChangePassword: boolean;
  readonly passwordExpiresAt: string | null;
}

export const ROLE_LABEL_KEY: Record<PlatformAccount['role'], MessageKey> = {
  superadmin: 'admin.accounts.role.superadmin',
  platform_admin: 'admin.accounts.role.platform_admin',
};

/** Mirrors `SuperadminPromotion` of `apps/api/src/modules/identity/superadmin-promotion.service.ts`. */
export interface SuperadminPromotion {
  readonly id: string;
  readonly targetUserId: string;
  readonly targetEmail: string;
  readonly requestedBy: string;
  readonly requestedByEmail: string;
  readonly reason: string;
  readonly status: 'pending' | 'confirmed' | 'rejected' | 'cancelled' | 'expired';
  readonly requestedAt: string;
  readonly expiresAt: string;
}

export const PROMOTION_STATUS_LABEL_KEY: Record<SuperadminPromotion['status'], MessageKey> = {
  pending: 'admin.promotions.status.pending',
  confirmed: 'admin.promotions.status.confirmed',
  rejected: 'admin.promotions.status.rejected',
  cancelled: 'admin.promotions.status.cancelled',
  expired: 'admin.promotions.status.expired',
};
